import React from 'react';
import MuiGrid, {GridProps} from '@material-ui/core/Grid';
import MuiFormControlLabel, {FormControlLabelProps} from '@material-ui/core/FormControlLabel';
import {withStyles, makeStyles, Radio} from '@material-ui/core';
import {getDirectionStyles} from '../../../../utils/ThemeUtils';

export const Grid: React.FC<GridProps> = ({children, ...props}) => (
    <MuiGrid container justifyContent="space-between" spacing={10} {...props}>
        {children}
    </MuiGrid>
);

export const GridItem: React.FC<GridProps> = ({children, ...props}) => (
    <MuiGrid item xs={12} lg={6} {...props}>
        {children}
    </MuiGrid>
);

export const FormControlLabel = withStyles(theme => ({
    root: {
        height: '100%',
        color: theme.palette.text.secondary
    }
}))(({label, ...props}: Partial<FormControlLabelProps>) => (
    <MuiFormControlLabel
        {...props}
        control={<Radio />}
        label={
            typeof label !== 'string' ? label : <span dangerouslySetInnerHTML={{__html: label}} />
        }
    />
));

const useStyles = makeStyles(theme => ({
    linkText: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    },
    linkIcon: {
        display: 'none',
        [theme.breakpoints.down('xs')]: {
            display: 'inherit',
            top: '3px',
            position: 'relative'
        }
    },
    paper: {
        padding: theme.spacing(4)
    },
    success: {
        color: theme.palette.success.light
    },
    warning: {
        color: theme.palette.warning.main
    },
    list: {
        padding: theme.spacing(0, 1)
    },
    listItem: {
        paddingRight: getDirectionStyles(theme.direction)(theme.spacing(12), theme.spacing(2)),
        paddingLeft: getDirectionStyles(theme.direction)(theme.spacing(2), theme.spacing(12))
    },
    listItemText: {
        textAlign: getDirectionStyles(theme.direction)('left', 'right')
    },
    listItemAction: {
        right: getDirectionStyles(theme.direction)(10, 'unset'),
        left: getDirectionStyles(theme.direction)('unset', 10)
    },
    radio: {
        margin: 0
    }
}));

export default useStyles;
